
import store from "@/store";
import {getColorFilter,rgbToHslV4 as rgbToHsl} from "@/utils/convert-color";
import * as Cookies from "js-cookie";
import configR from '@/configs.js';
let isLogin = Cookies.get("isLogin");
let userThemes = {
  getSelectedUserTheme(allThemes){
    let selectedThemes = allThemes.filter(enabledItem => enabledItem.enabled).filter(selectedItem => selectedItem.selected);
    let selectedTheme = null;
    if(isLogin) {
      if(selectedThemes && selectedThemes.length > 0) {
        selectedTheme = selectedThemes[0]
      }else {
        // =0
        selectedTheme = allThemes[0]
      }
    } else {
      selectedTheme = store.getters.touristThemeConfig && store.getters.touristThemeConfig.selectedTheme || null
      if(selectedTheme) { return selectedTheme;}

      if(!selectedTheme && selectedThemes && selectedThemes.length > 0) {
        selectedTheme = selectedThemes[0]
      }else if(allThemes && allThemes.length > 0) {
        selectedTheme = allThemes[0];
      }
    }
    return selectedTheme;
  },
  getPageList(selectedTheme){
    let pageList = selectedTheme && selectedTheme.pageList || [];
    for (let i = 0, len = pageList.length; i < len; i++) {
      for (let j = i + 1, len = pageList.length; j < len; j++) {
        if (pageList[i].pageCode === pageList[j].pageCode ) {
           pageList[j].pageCode = pageList[j].pageCode +j
          // pageList[j].pageName = pageList[j].pageName +j
        }
      }
    }
    return pageList;
  },
  getSelectedUserSkin(selectedTheme){
    let skinList = selectedTheme.skinList;
    let selectedSkins = skinList.filter(enabledItem => enabledItem.selected)
    let selectedSkin = null;
    if(isLogin) {
      if(selectedSkins && selectedSkins.length > 0 ) {
        // 有被选择的皮肤
        selectedSkin = selectedSkins[0];
      }
    } else {
      selectedSkin = store.getters.touristThemeConfig && store.getters.touristThemeConfig.currentSkinItem || null
      if(!selectedSkin && selectedSkins && selectedSkins.length > 0) {
        selectedSkin = selectedSkins[0]
      }
    }
    return selectedSkin;
  },
  getSelectedSkinColorInfo(selectedSkin) {
    let oldColor = ['0e', '6c', 'cb'];
    oldColor[0] = parseInt(oldColor[0], 16)
    oldColor[1] = parseInt(oldColor[1], 16)
    oldColor[2] = parseInt(oldColor[2], 16)
    let dominantColor = selectedSkin.color || "0e6ccb";
    dominantColor = dominantColor.substring(1, dominantColor.length)
    let list = [dominantColor.substring(0, 2), dominantColor.substring(2, 4), dominantColor.substring(4, 6)]
    list[0] = parseInt(list[0], 16)
    list[1] = parseInt(list[1], 16)
    list[2] = parseInt(list[2], 16)
    let oldHsl = rgbToHsl(oldColor)
    let newHsl = rgbToHsl(list)
    let delta = newHsl[0] - oldHsl[0]
    return {
      colorFilterDelta: delta,
      dominantColor: list
    }
  },
  // 用户默认皮肤
  useSystemDefaultSkin() {
    let defaultSkin = {};
    defaultSkin.preview = configR.envConfigs.VUE_APP_SKIN_IMG_URL || require("@/assets/Background/home.jpg");
    if (configR.envConfigs.VUE_APP_COLOR_FILTER_DELTA) {
      defaultSkin.colorFilterDelta = -parseFloat(configR.envConfigs.VUE_APP_COLOR_FILTER_DELTA);
    } else {
      defaultSkin.colorFilterDelta = '0'
    }
    return defaultSkin
  },

  setThemeConfig(allThemes,selectedTheme,selectedSkin){
    let themeConfig = {}
    themeConfig.themes = allThemes;
    themeConfig.currentTheme = selectedTheme.code;
    themeConfig.selectedTheme = selectedTheme;
    if(!selectedSkin){
      let defaultSkin = this.useSystemDefaultSkin();
      themeConfig.currentSkinItem = defaultSkin;
      themeConfig.currentSkinItem.colorFilterDelta = defaultSkin.colorFilterDelta;

    }else {
      let skinColorInfo = this.getSelectedSkinColorInfo(selectedSkin)
      themeConfig.currentSkinItem = selectedSkin;
      themeConfig.currentSkinItem.colorFilterDelta = skinColorInfo && skinColorInfo.colorFilterDelta || '';
      themeConfig.currentSkinItem.dominantColor = skinColorInfo && skinColorInfo.dominantColor || '';
    }
    store.commit("SET_USER_THEME_CONFIG",themeConfig);
    // if(!isLogin) { store.commit("SET_TOURIST_THEME_CONFIG",themeConfig);}
  }
}
export default userThemes;